import React from "react";
import { Building2, MapPin, Tag, LayoutGrid } from "lucide-react";

const InfoField = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-2.5">
    <div className="mt-0.5">
      <Icon size={16} className="text-themeColor" />
    </div>
    <div>
      <p className="text-darkColor/40 font-popinsRegular text-xs uppercase tracking-wide">{label}</p>
      <p className="text-darkColor font-popinsSemiBold text-sm mt-0.5">{value || "N/A"}</p>
    </div>
  </div>
);

const PropertyInfo = ({ leaseDetails }) => {
  const propertyName = leaseDetails?.propertyInfo?.propertyName || "N/A";
  const completeAddress = leaseDetails?.propertyInfo?.completeAddress || "N/A";
  const category = leaseDetails?.propertyInfo?.category || "N/A";
  const type = leaseDetails?.propertyInfo?.type || "N/A";
  const propertyImage = leaseDetails?.propertyInfo?.thumbnailImage?.url;

  return (
    <div className="bg-white rounded-xl p-5">
      {/* Heading */}
      <p className="text-darkColor font-popinsSemiBold text-xl leading-tight mb-4">
        {propertyName}
      </p>

      <div className="flex gap-5">
        {/* Left — Property Image */}
        <div className="flex-shrink-0 w-[140px] h-[140px] rounded-full overflow-hidden bg-gray-100">
          {propertyImage ? (
            <img
              src={propertyImage}
              alt={propertyName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-themeColor/10">
              <Building2 size={40} className="text-themeColor/40" />
            </div>
          )}
        </div>

        {/* Right — Property Fields */}
        <div className="flex-1">
          <p className="text-darkColor/40 font-popinsRegular text-xs uppercase tracking-widest mb-3">
            Property Information
          </p>
          <div className="grid grid-cols-2 gap-x-8 gap-y-4">
            <InfoField icon={Building2} label="Property Name" value={propertyName} />
            <InfoField icon={Tag} label="Category" value={category} />
            <InfoField icon={LayoutGrid} label="Type" value={type} />
            <div className="col-span-2 pt-1 border-t border-gray-100">
              <InfoField icon={MapPin} label="Complete Address" value={completeAddress} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyInfo;
